export const products = [
  {
    name: "Apple",
    price: 2,
    features: ["fresh", "tasty"],
    image:
      "https://i.pinimg.com/originals/1c/4a/04/1c4a04af246a66edebc6b05614e501e0.png",
  },
  {
    name: "Orange",
    price: 1.7,
    features: ["organic", "vitamin C"],
    image:
      "https://lh3.googleusercontent.com/proxy/zIxY2AaB0_JwyJgrHJdbhrjAgroFB9gnSO2f6DmOI2GIdLtxQ0ncn8DVuVp56b_F7IRVB91dZnISI1naej9fgIkzDaowm1OYGFQx2kAOlihNUD3gWyp-Vnx8cw",
  },
  {
    name: "Peach",
    price: 2.5,
    features: ["delicius", "incredible flavor"],
    image:
      "https://lh3.googleusercontent.com/proxy/bXeOK60sZmKwLL5TryxL3PqnPOP8HEU32SezOhdfw7HkHyeOHqUXPal9wcrDTV5j4pSbfb1nK9WHvSPlYGmNIiHkv9_ovvUCLhD-kvL-S6AjbIqn8PCSbjDruf_Uy6ezZDNamA",
  },
];
